import React, { useEffect } from "react";
import { Utils } from "../../../common/utils";
import { useValidate } from "formvalidation/hooks";
import { useSemanticUiInputRef } from "utilities/hookutils";
import InputBaseWithErrorLabel from "./InputBaseWithErrorLabel";
import { CommonInputProps } from "./models";

interface Props extends CommonInputProps {
  focusOnMount?: boolean;
  emailCanBeBlank: boolean
  maxLength?: number;
  onEsc?: () => void;
  onEnter?: () => void;
  hideErrorLabel?: boolean;
}

const EmailInput = (props: Props) => {
  const semanticInputRef = useSemanticUiInputRef();

  useEffect(() => {
    if (props.focusOnMount) {
      semanticInputRef.ref.current.focus();
    }
  }, []);

  const validate = async (email: string) => {
    const isEmailEmpty = email.trim().length === 0;

    if (isEmailEmpty) {
      return props.emailCanBeBlank || (props.hideErrorLabel ? false : RESX.GeneralWarnings.PleaseFillInThisField);
    }

    const isEmailValid = Utils.isValidEmailAddress(email);

    if (!isEmailValid) {
      return props.hideErrorLabel ? false : RESX.GeneralLabels.EmailIsInvalid;
    }

    return true;
  };

  const validation = useValidate({
    key: props.validatorKey,
    title: RESX.GeneralLabels.Email,
    value: props.value,
    validate: validate,
    ref: semanticInputRef.ref
  });

  const onKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Escape") {
      props.onEsc?.();
    } else if (e.key === "Enter") {
      props.onEnter?.();
    }
  }

  return <InputBaseWithErrorLabel
    fluid
    innerRef={semanticInputRef.refSetter}
    maxLength={props.maxLength ?? serverReference.constants.mailAddress.maxEmailLength}
    error={validation.error.errorMessage ?? validation.error.hasError}
    value={props.value}
    onChange={props.onChange}
    onKeyDown={onKeyDown}
    onBlur={validation.validateAndSetError}
  />

};

export default EmailInput;